import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CampaniasService {

  public url: string;
  // public idCampaniaList: string;
  // public select: string;
  // public filter: string;

  constructor(
    private http: HttpClient,
  ) {
    this.url = environment.url + 'api/campaigns/';
    // this.idCampaniaList = environment.idCampaniaList;
    // this.select = "$select=Title,Descripcion,Documento,Imagen,Contador,Habilitada,Link";
  }

  public getAll() {
    return this.http.get(this.url);
  }

  public enabledCampaignCounter() {
    let array: Array<any>;
    let filterArray: Array<any>;

    this.http.get(this.url).subscribe(
      (r: any) => {
        array = r.d.results;
        filterArray = array.filter(
          (cam: any) => { return cam.Habilitada }
        );
        return filterArray.length;
      },
      (err) => {
        console.log(err);
        return 0;
      }
    )
  }

  public getById(campaignId: number) {
    return this.http.get(this.url + campaignId);
  } 

  // public getByTopic(topicId: number) {
  //   this.filter = "&$filter=Topico eq " + topicId;
  //   return this.http.get(this.url + "_api/Web/Lists(" + this.idCampaniaList + ")/Items?" + this.select + this.filter);
  // }
}
